import type { Level } from "@/domain/learning/model/level";
import type { Progress } from "@/domain/progress/model/progress";

export type ResumeView =
  | { readonly kind: "intro" }
  | { readonly kind: "drill"; readonly lessonId: string; readonly drillId: string }
  | { readonly kind: "exam" }
  /** 昇段試験合格済み（朱印あり）。復習のため最初から（screen-flow.md §6.3 4行目）。 */
  | { readonly kind: "review-intro" };

/**
 * `Progress` から再開位置を導出する（screen-flow.md §6.3の決定表）。
 * URL にもストレージにも「現在位置」を持たせず、進捗の集合から毎回純粋に導出する（ADR-005）。
 * `clearedDrills` は `${levelId}:${drillId}` の合成キー（計画10で導入した規約）。
 */
export function deriveResumeView(level: Level, progress: Progress): ResumeView {
  if (progress.stamps.has(level.id)) {
    return { kind: "review-intro" };
  }

  const drills = level.lessons.flatMap((lesson) =>
    lesson.drills.map((drill) => ({ lessonId: lesson.id, drillId: drill.id })),
  );
  const clearedCount = drills.filter(({ drillId }) =>
    progress.clearedDrills.has(`${level.id}:${drillId}`),
  ).length;

  if (clearedCount === 0) {
    return { kind: "intro" };
  }

  if (clearedCount < drills.length) {
    const next = drills.find(
      ({ drillId }) => !progress.clearedDrills.has(`${level.id}:${drillId}`),
    );
    if (next) {
      return { kind: "drill", lessonId: next.lessonId, drillId: next.drillId };
    }
  }

  return { kind: "exam" };
}
